import {Component, input, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {Select} from 'primeng/select';
import {ToggleSwitch} from 'primeng/toggleswitch';
import {Tooltip} from 'primeng/tooltip';
import {CountryDetails} from '../../../../api';

@Component({
  selector: 'manage-country-modal',
  imports: [
    Button,
    FormsModule,
    InputText,
    Select,
    ToggleSwitch,
    Tooltip,
  ],
  templateUrl: './manage-country-modal.component.html',
  styleUrl: './manage-country-modal.component.scss',
})
export class ManageCountryModalComponent implements OnInit {
  modalData = input<CountryDetails>();

  localData: CountryDetails = {
    id: 'new',
    name: '',
    costGroup: undefined,
    enabled: true,
  };

  // ATO overseas cost groups
  readonly costGroupOptions = [1, 2, 3, 4, 5, 6].map((group) => ({label: `${group}`, value: group}));

  constructor(public ref: DynamicDialogRef) {}

  ngOnInit() {
    if (this.modalData()) {
      this.localData = {...this.modalData()!};
    }
  }

  get canSave(): boolean {
    return !!this.localData.name?.trim() && !!this.localData.costGroup;
  }

  closeDialog(data?: CountryDetails): void {
    this.ref.close(data);
  }
}
